// extracted by mini-css-extract-plugin
export var boldText = "_4k-4";
export var checkboxContainer = "_4k-6";
export var closeIcon = "_4k-i";
export var container = "_4k-0";
export var drawer = "_4k-8";
export var drawerContent = "_4k-9";
export var extraSmallText = "_4k-5";
export var fulfillmentGroupTable = "_4k-e";
export var largeText = "_4k-3";
export var loadingSpinnerContainer = "_4k-j";
export var mediumText = "_4k-2";
export var narrow = "_4k-f";
export var notificationLink = "_4k-l";
export var packageCheckIconContainer = "_4k-7";
export var slideoutHeaderActions = "_4k-g";
export var slideoutHeaderActionsShifted = "_4k-h";
export var slideoutHeaderContainer = "_4k-a";
export var slideoutModal = "_4k-c";
export var stickyHeaderWrapper = "_4k-b";
export var table = "_4k-k";
export var tableContainer = "_4k-d";
export var tertiaryText = "_4k-1";